import { isAxiosError } from 'axios'
import { logger } from '@/lib/logger'

const DEV_HINT =
  'Start brushfire-notification-service on :4005 (`pnpm dev` in brushfire-notification-service), then refresh.'

let devNotificationBackendUnavailable = false

/** Vitest only — resets module guard between cases. */
export function resetNotificationDevBackendForTests(): void {
  devNotificationBackendUnavailable = false
}

export function isDevNotificationBackendDisabled(): boolean {
  return import.meta.env.DEV && devNotificationBackendUnavailable
}

/** True when Vite proxy cannot reach notification :4005 (ECONNREFUSED). */
export function isNotificationUnavailableError(err: unknown): boolean {
  if (!isAxiosError(err)) return false
  if (err.code === 'ERR_NETWORK' || err.code === 'ECONNREFUSED') return true
  const status = err.response?.status
  if (status === 502 || status === 503 || status === 504) return true
  // Vite dev proxy surfaces upstream refusal as 500 with empty/minimal body.
  if (import.meta.env.DEV && status === 500) return true
  return false
}

export function markDevNotificationBackendUnavailable(cause?: unknown): void {
  if (!import.meta.env.DEV || devNotificationBackendUnavailable) return
  devNotificationBackendUnavailable = true
  const reason =
    cause instanceof Error || isAxiosError(cause) ? cause.message : undefined
  logger.warn('notification.dev_backend_unavailable', {
    reason,
    hint: DEV_HINT,
  })
}

export const notificationDevQueryOptions = {
  enabled: () => !isDevNotificationBackendDisabled(),
  retry: import.meta.env.DEV ? (false as const) : undefined,
  refetchOnWindowFocus: import.meta.env.DEV ? (false as const) : undefined,
}
